<app-button-copy-clipboard
  [type]="type"
  tooltip="reports.copy_link"
  [value]="link"></app-button-copy-clipboard>
